export const LABELS = {
  convertToIssue: 'Convert to issue',
  moveUp: 'Move up',
  moveDown: 'Move down',
  openTaskOptions: (title: string) => `Open ${title} task options`,
}
